
import { computed, ref } from "vue";
import { useStore } from "vuex";
import _ from "lodash";
import {
  BulletListDto,
  MessageType
} from "@moderrotech/servers-communication-library/src/types";
import { showToastError, showToastSuccess } from "@/helpers/notification";
import { i18n } from "@/lang";
import { getTextDirection } from "@/helpers/string";
import ProgressBar from "@/components/ProgressBar.vue";
/* eslint-disable */
// @ts-ignore
import {copyText} from 'vue3-clipboard'
/* eslint-enable */

export default {
  components: { ProgressBar },
  setup() {
    const store = useStore();

    const bulletList = computed(
      (): BulletListDto => store.state.session.bulletList
    );

    const activeItem = ref<string>();

    const isPaused = ref(false);

    return {
      bulletList,
      getTextDirection,
      activeItem,
      handleCopyClick: () =>
        copyText(
          _.join(bulletList.value?.items, "\n"),
          undefined,
          (error: any, event: any) =>
            error
              ? showToastError(i18n.global.t("call.error.textCopy"))
              : showToastSuccess(i18n.global.t("call.success.textCopy"))
        ),
      handleCloseClick: () => store.commit("session/UNSET_BULLET_LIST"),
      handleSelected: (text: string) => {
        activeItem.value = text;
        store.dispatch("session/sendJsonMessage", {
          message: {
            type: MessageType.bulletListClick,
            item: text
          }
        });
        store.commit("session/UNSET_BULLET_LIST");
      },
      handleProgressEnd: () => store.commit("session/UNSET_BULLET_LIST"),
      isPaused
    };
  }
};
